import Vue from 'vue'

import perm from './perm'
import resize from './resize'

Vue.use(perm)
Vue.use(resize)
